import {
  AccessControl,
  WarehouseLocationFeature,
} from '@retailer-platform/dashboard/access-control'
import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureEntitlements } from './featureEntitlements'

/**
 * Access control for the legacy "Device accounts" tool. Mutually exclusive with the
 * "Equipment data" tool: any partner with the PartnerBulkDeliveryEnabled entitlement is
 * routed to "Equipment data" instead, so this config explicitly excludes them via
 * `notFeatureEntitlementIds`.
 */
export const partnerPickDevicesAccessControl: DomainAccessControlConfig = [
  // permissions and warehouseLocationFeatures both must be enabled
  {
    permissions: Permission.PartnerPickDevicesManageShoppers,
    warehouseLocationFeatures: AccessControl.oneOf([
      WarehouseLocationFeature.RetailerPickup,
      WarehouseLocationFeature.RetailerAlcoholDelivery,
    ]),
    notFeatureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    restrictedBannersAllowed: true,
  },
  {
    permissions: Permission.PartnerPickDevicesManageShoppers,
    warehouseLocationFeatures: AccessControl.oneOf([
      WarehouseLocationFeature.RetailerPickup,
      WarehouseLocationFeature.RetailerAlcoholDelivery,
    ]),
    notFeatureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    restrictedBannersAllowed: true,
  },
  {
    permissions: Permission.PartnerPickDevicesManageShoppers,
    featureEntitlementIds: [FeatureEntitlements.ScanAndPayRetailers],
    notFeatureEntitlementIds: [FeatureEntitlements.PartnerBulkDeliveryEnabled],
    restrictedBannersAllowed: true,
  },
]
